import HttpClient from "../HttpClient";
import { CreateResult, GetListResult, GetOneResult, UpdateResult } from "react-admin";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import { ReasonSubReasonResponse } from "../interfaces/ReasonSubReason/ReasonSubReasonResponse";
import { CreateReasonSubReason } from "../interfaces/ReasonSubReason/CreateReasonSubReason";
import { UpdateReasonSubReason } from "../interfaces/ReasonSubReason/UpdateReasonSubReason";

export default class reasonSubreasonService {
    async fetchReasonAndSubReason(
        module: string,
        actionType: string
    ): Promise<GetOneResult> {
        let data = await HttpClient.get(`/reasonSubreason?module=${module}&actionType=${actionType}`, {
        });
        return {
            data
        };
    }

    async fetchAllReasonSubreason(
        limit: number,
        offset: number,
        filters: any,
        sort: {}
    ): Promise<GetListResult<ReasonSubReasonResponse>> {
        filters = ConstructSequelizeFilters(
            filters,
            ["reason", "subReason"],
            ["module", "actionType", "clientId", "isActive", "isVisible"],
        );
        const data = await HttpClient.get("/centaurus/reason-subreason", {
            params: {
                limit,
                offset,
                filters,
                sort,
            },
        });
        return {
            data: (!!data && !!data?.data) ? data?.data?.data : [],
            total: (!!data && !!data?.data) ? data?.data?.count : 0,
        };
    }

    async getOneReasonSubreason(id: number): Promise<GetOneResult<ReasonSubReasonResponse>> {
        const res = await HttpClient.get(`/centaurus/reason-subreason/${id}`);
        return {
            data: res?.data,
        };
    }

    async createReasonSubreason(payload: CreateReasonSubReason): Promise<CreateResult<ReasonSubReasonResponse>> {
        const res = await HttpClient.post(`/centaurus/reason-subreason`, payload);
        return {
            data: res?.data,
        };
    }

    async updateReasonSubreason(id: number, payload: UpdateReasonSubReason): Promise<UpdateResult<ReasonSubReasonResponse>> {
        const res = await HttpClient.patch(`/centaurus/reason-subreason/${id}`, payload);
        return {
            data: res?.data,
        };
    }
}
